'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# LogoSVG
The Ohio State Bar Association logo
 */
var LogoSVG = function LogoSVG(_ref) {
  var height = _ref.height,
      width = _ref.width,
      primaryColor = _ref.primaryColor,
      backgroundColor = _ref.backgroundColor;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 157.6 157.6',
      'aria-label': 'OSBA Logo',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'OSBA Logo'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'The Ohio State Bar Association logo'
    ),
    _react2.default.createElement('path', { fill: backgroundColor, d: 'M0 0h157.6v157.6H0z' }),
    _react2.default.createElement('path', {
      fill: primaryColor,
      d: 'M104.3 82.4h5.6c3.9-8.4 2.5-16.8-1.7-21.9h-7.9c3.2 2.7 6.6 12 4 21.9zm30.8 0c4.5-7.2\r 4.2-18.6-.6-21.9h-3.7c6.7 4.5 4.2 15.6 1.4 21.9h2.9zm-19.4-21.9h-3.6c6.7 4.5 5.1 14.4 2.8 21.9h2.8c4.8-7.2\r 3-19.1-2-21.9zM85.4 106v39.9l6.9-2.7.1-31.6v-3.1c.4-3.3 3.2-3.3 3.3 0v33.4l3.2-1.2V97.4c.2-2-4.2 6.2-13.5\r 8.6zM74.1 37.1l71.7-.1V10.2c-18.9 6-43.5 13.2-60.7 17.3-10 2.3-20.4-6.3-26.8-14.7H11.7v109.9l62.4\r 24.8v-41.4c-46.9-1.4-45.3-67.2 0-69zm53.3 23.4h-7.3c4.8 2.7 6.5 14.4 2 21.9h6.5c4.7-6.6 3.6-18.6-1.2-21.9zm-24.2\r 39.8v38.6l7-2.7v-27.9c.4-3.3 3.2-3.3 3.3 0v26.6l3.2-1.2v-33.4c.4-8.7-13.1-8.4-13.5 0zm36.2-17.9h6.4V60.5h-6.9c4.7\r 2.7 5 14.4.5 21.9zM73.2 45.9C42.6 47.1 40 98.4 75.7 98c19.2-1.2 23.1-14.8 22.2-23.3-1.1-9.4-8.4-16.5-18.5-16.2-17.4.6-20.5\r 26.8-1.7 28.9 8.6.6 11.3-5.5 11.6-10 .2-8.1-7.1-11.3-11.6-9.6-3.9 1.7-5.2 7.5-.6 10.6-1-1-4.1-6.6 1-9.1 5.3-1.8 9 2.6 8.9\r 7.3-.1 3.7-1.9 8.7-9.2 8.1-4.5-.5-8.7-3.7-9.6-9.8-.8-7.9 4.7-13.1 11.2-13.3 4.5-.2 9.6 1.6 13.2 7.9 5.9 12.3-6.4 25.9-19.4\r 22.8-24.7-7.2-18.3-36.6 0-38.4h72.5v-8.1H73.2v.1zm29.4 44.4h43.1v-2.4h-42.3l-.8 2.4zm17.7 10.2v31.9l7-2.7v-22.1c.4-3.3\r 3.2-3.3 3.3 0v20.9l3.2-1.2v-26.6c.4-8.9-13.1-8.6-13.5-.2zm17.7-.8v25.8l7.7-3V94c0-.3-6.6-1.5-7.7 5.7z'
    })
  );
};

LogoSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** primary color for the logo */
  primaryColor: _propTypes2.default.string,
  /** background color for the logo */
  backgroundColor: _propTypes2.default.string
};

LogoSVG.defaultProps = {
  height: undefined,
  width: undefined,
  primaryColor: _config.colors.white,
  backgroundColor: _config.colors.darkRed
};

LogoSVG.displayName = 'LogoSVG';

exports.default = LogoSVG;
LogoSVG.__docgenInfo = {
  'description': '# LogoSVG\r\nThe Ohio State Bar Association logo',
  'methods': [],
  'displayName': 'LogoSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'primaryColor': {
      'defaultValue': {
        'value': 'colors.white',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'primary color for the logo'
    },
    'backgroundColor': {
      'defaultValue': {
        'value': 'colors.darkRed',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'background color for the logo'
    }
  }
};